<button mat-icon-button (click)="showNav = !showNav">
  <mat-icon>menu</mat-icon>
</button>
@if (showNav) {
  <mat-nav-list style="width: 250px">
    <a mat-list-item routerLink="/">Dashboard</a>
    @if (showPartners) {
      <a mat-list-item routerLink="/partner">Partners</a>
    }
    @if (showPartners) {
      <a mat-list-item routerLink="/partner-functions">Partner Functions</a>
    }
    @if (showPartners) {
      <a mat-list-item routerLink="/integration-log">Integration Log</a>
    }
    @if (showPartners) {
      <a mat-list-item routerLink="/transactions">Transaction Log</a>
    }
    @if (showPartners) {
      <a mat-list-item routerLink="/apikeys">API Keys</a>
    }
  </mat-nav-list>
}
